import {
  LFI_PAIR_LIST,
  LFO_PAIR_LIST,
  LRI_PAIR_LIST,
  LRO_PAIR_LIST,
  RFI_PAIR_LIST,
  RFO_PAIR_LIST,
  RRI_PAIR_LIST,
  RRO_PAIR_LIST,
} from './pairLists';

export const STATUS_OPTION_LIST = [
  { label: 'ALL', value: 'ALL' },
  { label: 'Damaged', value: 'SSD001' },
  { label: 'Repaired', value: 'SSD002' },
];

export const STATUS_FORM_OPTION_LIST = [
  { label: 'Damaged', value: 'SSD001' },
  { label: 'Repaired', value: 'SSD002' },
];

export const TRUCK_DAMAGE_CHECKBOX_FIRST_OPTION_LIST = [
  { key: 0, label: 'ABS', inputName: 'trk_abs' },
  { key: 1, label: 'Battery', inputName: 'trk_battery' },
  { key: 2, label: 'Engine Light', inputName: 'trk_engine_light' },
  { key: 3, label: 'Hoses', inputName: 'trk_hoses' },
  { key: 4, label: 'Windshield', inputName: 'trk_windshield' },
  { key: 5, label: 'Lights', inputName: 'trk_lights' },
  { key: 6, label: 'Mirrors', inputName: 'trk_mirrors' },
  { key: 7, label: 'Mud Flaps', inputName: 'trk_mudflap' },
  { key: 8, label: 'Reflectors', inputName: 'trk_reflectors' },
  { key: 9, label: 'Turn Indicators', inputName: 'trk_turn_indicators' },
];

export const CHASSIS_DAMAGE_CHECKBOX_OPTION_LIST = [
  { key: 0, label: 'ABS', inputName: 'ch_abs' },
  { key: 1, label: 'Air Leak', inputName: 'ch_air_leak' },
  { key: 2, label: 'Brake Chamber', inputName: 'ch_brake_chamber' },
  { key: 3, label: 'Brakes', inputName: 'ch_brakes' },
  { key: 4, label: 'Hub Cap', inputName: 'ch_hubcap' },
  { key: 5, label: 'Landing Gear', inputName: 'ch_landing_gear' },
  { key: 6, label: 'Lights', inputName: 'ch_lights' },
  { key: 7, label: 'Mud Flaps', inputName: 'ch_mudflap' },
  { key: 8, label: '7-Way Plug', inputName: 'ch_7_way_plug' },
];

export const STEER_TIRES_CHECKBOX_OPTION_LIST = [
  {
    key: 0,
    label: 'Damaged (Left)',
    inputName: 'st_left_dmg',
    width: 'w-[164px]',
  },
  {
    key: 1,
    label: 'Damaged (Right)',
    inputName: 'st_right_dmg',
    width: 'w-[164px]',
  },
];

export const DRIVER_TIRES_CHECKBOX_OPTION_LIST = [
  {
    key: 0,
    label: 'Damaged',
    inputName: 'dt_lfo_dmg',
    subLabel: 'LFO',
    width: 'w-[71px]',
  },
  {
    key: 1,
    label: 'Damaged',
    inputName: 'dt_lfi_dmg',
    subLabel: 'LFI',
    width: 'w-[71px]',
  },
  {
    key: 2,
    label: 'Damaged',
    inputName: 'dt_rfo_dmg',
    subLabel: 'RFO',
    width: 'w-[71px]',
  },
  {
    key: 3,
    label: 'Damaged',
    inputName: 'dt_rfi_dmg',
    subLabel: 'RFI',
    width: 'w-[71px]',
  },
  {
    key: 4,
    label: 'Damaged',
    inputName: 'dt_lro_dmg',
    subLabel: 'LRO',
    width: 'w-[71px]',
  },
  {
    key: 5,
    label: 'Damaged',
    inputName: 'dt_lri_dmg',
    subLabel: 'LRI',
    width: 'w-[71px]',
  },
  {
    key: 6,
    label: 'Damaged',
    inputName: 'dt_rro_dmg',
    subLabel: 'RRO',
    width: 'w-[71px]',
  },
  {
    key: 7,
    label: 'Damaged',
    inputName: 'dt_rri_dmg',
    subLabel: 'RRI',
    width: 'w-[71px]',
  },
];

export const TRAILER_CHASSIS_TIRES_CHECKBOX_OPTION_LIST = [
  {
    key: 0,
    label: 'Original',
    subLabel: 'LFO',
    inputName: 'tct_lfo_orig',
    width: 'w-[71px]',
    pairs: LFO_PAIR_LIST,
  },
  {
    key: 1,
    label: 'Original',
    subLabel: 'LFI',
    inputName: 'tct_lfi_orig',
    width: 'w-[71px]',
    pairs: LFI_PAIR_LIST,
  },
  {
    key: 2,
    label: 'Original',
    subLabel: 'RFO',
    inputName: 'tct_rfo_orig',
    width: 'w-[71px]',
    pairs: RFO_PAIR_LIST,
  },
  {
    key: 3,
    label: 'Original',
    subLabel: 'RFI',
    inputName: 'tct_rfi_orig',
    width: 'w-[71px]',
    pairs: RFI_PAIR_LIST,
  },
  {
    key: 4,
    label: 'Damaged',
    inputName: 'tct_lfo_dmg',
    width: 'w-[71px]',
    pairs: LFO_PAIR_LIST,
  },
  {
    key: 5,
    label: 'Damaged',
    inputName: 'tct_lfi_dmg',
    width: 'w-[71px]',
    pairs: LFI_PAIR_LIST,
  },
  {
    key: 6,
    label: 'Damaged',
    inputName: 'tct_rfo_dmg',
    width: 'w-[71px]',
    pairs: RFO_PAIR_LIST,
  },
  {
    key: 7,
    label: 'Damaged',
    inputName: 'tct_rfi_dmg',
    width: 'w-[71px]',
    pairs: RFI_PAIR_LIST,
  },
];

export const TRAILER_CHASSIS_TIRES_CHECKBOX_OPTION_LIST2 = [
  {
    key: 0,
    label: 'Original',
    subLabel: 'LRO',
    inputName: 'tct_lro_orig',
    width: 'w-[71px]',
    pairs: LRO_PAIR_LIST,
  },
  {
    key: 1,
    label: 'Original',
    subLabel: 'LRI',
    inputName: 'tct_lri_orig',
    width: 'w-[71px]',
    pairs: LRI_PAIR_LIST,
  },
  {
    key: 2,
    label: 'Original',
    subLabel: 'RRO',
    inputName: 'tct_rro_orig',
    width: 'w-[71px]',
    pairs: RRO_PAIR_LIST,
  },
  {
    key: 3,
    label: 'Original',
    subLabel: 'RRI',
    inputName: 'tct_rri_orig',
    width: 'w-[71px]',
    pairs: RRI_PAIR_LIST,
  },
  {
    key: 4,
    label: 'Damaged',
    inputName: 'tct_lro_dmg',
    width: 'w-[71px]',
    pairs: LRO_PAIR_LIST,
  },
  {
    key: 5,
    label: 'Damaged',
    inputName: 'tct_lri_dmg',
    width: 'w-[71px]',
    pairs: LRI_PAIR_LIST,
  },
  {
    key: 6,
    label: 'Damaged',
    inputName: 'tct_rro_dmg',
    width: 'w-[71px]',
    pairs: RRO_PAIR_LIST,
  },
  {
    key: 7,
    label: 'Damaged',
    inputName: 'tct_rri_dmg',
    width: 'w-[71px]',
    pairs: RRI_PAIR_LIST,
  },
];

export const IS_NGL_TRUCK_OPTION = [
  {
    inputName: 'isNGLTruck',
    optionLabel: 'NGL',
  },
];

export const IS_NGL_CHASSIS_OPTION = [
  {
    inputName: 'isNGLChassis',
    optionLabel: 'NGL',
  },
];
